/* ==========================================================================
   aw_bestellstatus.js — Zustands-Renderer der Bestellstatus-Seite.
   Portiert aus 80_bestellstatus_tracking/bestellstatus_mockup.html.

   Datenpfade:
     (1) demo_modus (data-demo="true")  -> eingebaute Beispiel-Daten; im
         Shopify.designMode zusaetzlich ein verstecktes Dev-Auswahlfeld (Staende).
     (2) sonst -> fetch(endpoint + '?order=..&sig=..') mit den URL-Parametern
         'order' und 'sig' durchgereicht. Bei 404/Netzwerkfehler: freundlicher
         Fallback + Hinweis auf den Link in der Bestell-Mail + Kundenkonto-Link.
     (3) kein 'order'-Param & nicht Demo -> Zugangs-Karte (E-Mail-Login / Mail-Link).

   Erwartetes API-JSON (Backend folgt) — Feldnamen mit sinnvollen Fallbacks in
   mapApi(); die Anzeige-Strings ("voraussichtlich …", Termine) liefert das
   Backend fertig formatiert (Werktags-/Lead-Time-Logik = Serverseite).

   13.09.2026: product_noun („Relief“ / „TrailMap“) setzt Produktwort, Karten-Tag,
   alt-Text und die Standard-Überschrift. progress_pct speist die Prozentzahl im
   Status-Kopf, fehlt es, rechnet progressPct() dieselbe Regel lokal.
   Stephan: „und für trailmaps brauchen wir das auch :-)“ · „kannst du oben noch
   einen prozent status bauen ? also eine Zahl wie weit ? nach status“.
   ========================================================================== */
(function () {
  'use strict';

  // Schritt modell heißt „3D-Modell erstellt und geprüft“. Stephan 13.09.2026: „und nenn alles
  // 3d modell erstellt und überprüft oder sowas“ · „damit man sieht dass es nicht alles
  // automatisch passiert sondern premium is“.
  var STEP_DEFS = [
    { key: 'eingang',    name: 'Bestellung eingegangen' },
    { key: 'modell',     name: '3D-Modell erstellt und geprüft' },
    { key: 'druck',      name: 'Im 3D-Druck' },
    { key: 'gravur',     name: 'Gravur' },            // nur wenn Gravur bestellt
    { key: 'montage',    name: 'Montage & Prüfung' },
    { key: 'versand',    name: 'Versand' },
    { key: 'zustellung', name: 'Zugestellt' }
  ];
  // Produktwort mit Grammatik (das Relief, die TrailMap). Schrittnamen der TrailMap folgen den
  // Sätzen aus status_api._now_text („Gerade in der Fertigung“, „von Hand fertiggestellt“).
  var NOUNS = {
    Relief:   { dein: 'Dein Relief', deines: 'Deines Reliefs', frage: 'Wo ist mein Relief?' },
    TrailMap: { dein: 'Deine TrailMap', deines: 'Deiner TrailMap', frage: 'Wo ist meine TrailMap?',
                steps: { druck: 'In der Fertigung', montage: 'Fertigstellung & Prüfung' } },
    // Mehrere Werkstücke (zwei Reliefs, TrailMap und Relief) oder Menge ab 2: status_api liefert „Bestellung“.
    // Stephan 13.09.2026: „Und wie schaut die Seite aus wenn zwei Relief bestellt oder z.b eine Trailmap und ein Relief??“
    Bestellung: { dein: 'Deine Bestellung', deines: 'Deiner Bestellung', frage: 'Wo ist meine Bestellung?' }
  };
  function nounForms(noun) { return NOUNS[noun] || NOUNS.Relief; }
  var STD_HEADINGS = Object.keys(NOUNS).map(function (k) { return NOUNS[k].frage; });

  // Fortschritt 0..100 nach Aufwand, dieselbe Regel und dieselben Gewichte wie
  // status_api.progress_pct / PROGRESS_WEIGHTS. Greift nur, wenn das Backend kein progress_pct liefert.
  // Zugestellt = 100, Zahlung offen = 0, sonst Summe der Gewichte vor dem aktiven Schritt plus das halbe
  // Gewicht des aktiven, Math.round (x,5 nach oben, im Backend ebenso).
  // Stephan 13.09.2026: „14325 . 50%????? Muss doch nur noch montiert und verpackt werden“.
  var PROGRESS_WEIGHTS = {
    mit:  { eingang: 5, modell: 10, druck: 45, gravur: 15, montage: 10, versand: 5, zustellung: 10 },
    ohne: { eingang: 5, modell: 10, druck: 60, montage: 10, versand: 5, zustellung: 10 }
  };
  function progressPct(m, steps, idx) {
    var p = Number(m.progressPct);
    if (m.progressPct != null && m.progressPct !== '' && isFinite(p)) return Math.max(0, Math.min(100, Math.round(p)));
    if (m.delivered) return 100;
    if (m.pay || idx < 0 || !steps.length) return 0;
    var mitGravur = steps.some(function (s) { return s.key === 'gravur'; });
    var w = PROGRESS_WEIGHTS[mitGravur ? 'mit' : 'ohne'];
    var summe = 0, i;
    for (i = 0; i < idx; i++) summe += w[steps[i].key] || 0;
    summe += (w[steps[idx].key] || 0) / 2;
    return Math.max(0, Math.min(100, Math.round(summe)));
  }

  var SVGNS = 'http://www.w3.org/2000/svg';
  // Anmeldung der neuen Kundenkonten: /customer_authentication/login nimmt return_to (relativer Pfad derselben
  // Domain) und führt nach dem Login dorthin zurück. Ziel ist die Statusseite mit order und sig aus der Mail; das
  // Backend zeigt eingeloggt diese Bestellung, wenn sie dem Kunden gehört, sonst die neueste.
  var LOGIN_FALLBACK = '/customer_authentication/login';
  function kontoLink(section) {
    var login = section.getAttribute('data-login-url') || LOGIN_FALLBACK;
    var p = new URLSearchParams(window.location.search), keep = [];
    ['order', 'sig'].forEach(function (k) { var v = p.get(k); if (v) keep.push(k + '=' + encodeURIComponent(v)); });
    // nur ein führender Schrägstrich: „//host“ wäre ein fremdes Ziel
    var ziel = '/' + String(window.location.pathname || '').replace(/^\/+/, '') + (keep.length ? '?' + keep.join('&') : '');
    return login + (login.indexOf('?') > -1 ? '&' : '?') + 'return_to=' + encodeURIComponent(ziel);
  }

  function r1(n) { return Math.round(n * 10) / 10; }
  function r2(n) { return Math.round(n * 100) / 100; }

  // ---- Der Berg ist die Leiste: EINE Abbildung Prozent -> x auf dem Grat ----
  // Stephan 13.09.2026: „Der prozentbalken deckt sich aber nicht mit dem Bergprofil“.
  // Deckung als Konstruktion statt als Absprache: Grat-Fortschritt (clip), aktueller Punkt, Marke mit der
  // Zahl und der Strich zur Beschriftung holen ihr x ausschließlich aus pctToX() bzw. pctToCss(), und zwar
  // aus DEMSELBEN Prozentwert, der im Kopf steht. Der aktuelle Punkt steht nicht „ungefähr“ beim Wert, er
  // IST der Wert. Die Stationen stehen fest nach Aufwand (stationPcts). Wer hier eine zweite Umrechnung
  // einführt, reißt die Deckung wieder auf. Prüfung: final/harness_final.py bricht bei Deckung über 2 px ab.
  var RIDGE = { xL: 86, xR: 1114, yB: 192, yT: 26, W: 1200, H: 240 };
  function clampPct(p) { p = Number(p); return isFinite(p) ? Math.max(0, Math.min(100, p)) : 0; }
  function pctToX(p) { return RIDGE.xL + (RIDGE.xR - RIDGE.xL) * clampPct(p) / 100; }
  // Dieselbe Position als Anteil der Grafikbreite (HTML-Ebenen über und unter dem SVG, Breite = SVG-Breite)
  function pctToCss(p) { return r2(pctToX(p) / RIDGE.W * 100); }
  // h(t): streng steigend auf [0,1] (Linear + Smoothstep), y fällt streng, der Grat geht nie abwärts
  function ridgeH(t) { var e = t * t * (3 - 2 * t); return 0.45 * t + 0.55 * e; }
  function ridgeY(x) {
    var t = Math.max(0, Math.min(1, (x - RIDGE.xL) / (RIDGE.xR - RIDGE.xL)));
    return RIDGE.yB - (RIDGE.yB - RIDGE.yT) * ridgeH(t);
  }

  // Stationen in Prozent. Regel-Position = Mitte des eigenen Aufwands (dieselbe Regel wie progressPct),
  // Zugestellt steht immer am Gipfel (100). Damit steht jede Station bei jedem Besuch derselben Bestellung
  // an derselben Stelle, auch „Zugestellt“ springt beim Zustellen nicht.
  // Der aktuelle Punkt steht IMMER auf pct. Liegt pct im Aufwands-Intervall des aktiven Schritts (Normalfall,
  // das Backend rechnet dieselbe Regel), rückt die aktive Station auf pct, die Nachbarn weichen um höchstens
  // bis zum Mindestabstand GAP aus. Passt das nicht in 0..100, oder liegt pct außerhalb des Intervalls
  // (abweichende Backend-Daten), bleiben alle Stationen auf der Regel und der Punkt steht zwischen zwei Stationen.
  // Rückgabe: p (Prozent je Station), onStation (Punkt fällt mit der aktiven Station zusammen).
  var GAP = 5;
  function stationPcts(steps, anchorIdx, pct) {
    var n = steps.length, mitGravur = steps.some(function (s) { return s.key === 'gravur'; });
    var w = PROGRESS_WEIGHTS[mitGravur ? 'mit' : 'ohne'], rule = [], lo = [], hi = [], summe = 0, i;
    for (i = 0; i < n; i++) { var g = w[steps[i].key] || 0; lo.push(summe); rule.push(summe + g / 2); summe += g; hi.push(summe); }
    var f = summe > 0 ? 100 / summe : 1;
    rule = rule.map(function (v) { return v * f; }); lo = lo.map(function (v) { return v * f; }); hi = hi.map(function (v) { return v * f; });
    if (n && steps[n - 1].key === 'zustellung') rule[n - 1] = 100;
    pct = clampPct(pct);
    if (anchorIdx < 0 || anchorIdx >= n) return { p: rule, onStation: false };
    if (steps[anchorIdx].key === 'zustellung') return { p: rule, onStation: Math.abs(rule[anchorIdx] - pct) < 0.05 };
    if (pct < lo[anchorIdx] - 0.05 || pct > hi[anchorIdx] + 0.05) return { p: rule, onStation: Math.abs(rule[anchorIdx] - pct) < 0.05 };
    var p = rule.slice();
    p[anchorIdx] = pct;
    for (i = anchorIdx + 1; i < n; i++) p[i] = Math.max(p[i], p[i - 1] + GAP);
    for (i = anchorIdx - 1; i >= 0; i--) p[i] = Math.min(p[i], p[i + 1] - GAP);
    if (p[0] < 0 || p[n - 1] > 100) return { p: rule, onStation: Math.abs(rule[anchorIdx] - pct) < 0.05 };
    return { p: p, onStation: true };
  }

  // Beschriftungen in zwei versetzten Reihen, Belegung FEST nach Schrittindex: ungerade Indizes oben
  // (3D-Modell, Gravur bzw. Montage, ...), gerade unten (Eingang, Druck, ...). Nicht vom Zustand abhängig,
  // die Seite sieht bei jedem Besuch gleich aus. Ungerade oben, weil links Eingang und 3D-Modell eng stehen:
  // so bekommt „Bestellung eingegangen“ unten die breite Box bis zur Mitte zum Druck.
  // Obere Reihe: Box zwischen den Strichen der Nachbarn (die Striche der unteren Reihe laufen zwischen ihnen
  // hindurch). Untere Reihe: Box bis zur Mitte zum nächsten Nachbarn derselben Reihe. Werte in % der Grafikbreite.
  function labelSlots(cx) {
    var n = cx.length, slots = [], i;
    for (i = 0; i < n; i++) {
      if (i % 2 === 1) {
        slots.push({ row: 1, lb: cx[i - 1], rb: i < n - 1 ? cx[i + 1] : 100, lbm: 10, rbm: i < n - 1 ? 10 : 0 });
      } else {
        slots.push({ row: 2, lb: i > 1 ? (cx[i - 2] + cx[i]) / 2 : 0, rb: i < n - 2 ? (cx[i] + cx[i + 2]) / 2 : 100,
                     lbm: i > 1 ? 8 : 0, rbm: i < n - 2 ? 8 : 0 });
      }
    }
    return slots;
  }

  // ---- Berg-Geometrie: Grat durch die Stationen (streng steigend, nie abwärts) ----
  function geom(stX) {
    var SEG = 48, pts = [], k, xL = RIDGE.xL, xR = RIDGE.xR, yB = RIDGE.yB, yT = RIDGE.yT, W = RIDGE.W, H = RIDGE.H;
    for (k = 0; k <= SEG; k++) pts.push(r1(xL + (xR - xL) * k / SEG));
    // Stationen als eigene Stützpunkte: jede liegt exakt auf der Linie, auch zwischen zwei Stützstellen
    stX.forEach(function (x) { pts.push(r1(x)); });
    pts.sort(function (a, b) { return a - b; });
    pts = pts.filter(function (x, i) { return i === 0 || x - pts[i - 1] > 0.05; });
    var d = '';
    pts.forEach(function (x, i) { d += (i === 0 ? 'M' : ' L') + x + ',' + r1(ridgeY(x)); });
    // EIN Bergkörper: kurze linke Vorflanke, Route, Gipfel, stille Schulter (nur Fläche)
    var shade = 'M0,' + H + ' L0,' + r1(yB + 22) + ' ' + r1(xL * 0.5) + ',' + r1(yB + 6);
    pts.forEach(function (x) { shade += ' ' + x + ',' + r1(ridgeY(x)); });
    shade += ' ' + r1(xR + 24) + ',' + r1(yT + 22) + ' ' + r1(xR + 60) + ',' + r1(yT + 40) +
             ' ' + r1(W - 20) + ',' + r1(yT + 66) + ' ' + W + ',' + r1(yT + 82) +
             ' L' + W + ',' + H + ' Z';
    return { d: d, shade: shade, yT: yT, xR: xR };
  }

  function svgEl(name, attrs) {
    var el = document.createElementNS(SVGNS, name), a;
    for (a in attrs) { if (attrs.hasOwnProperty(a)) el.setAttribute(a, attrs[a]); }
    return el;
  }
  function q(root, sel) { return root.querySelector('[data-awbs="' + sel + '"]'); }
  function setLeadText(el, obj) {
    el.textContent = '';
    if (!obj) return;
    if (obj.lead) { var b = document.createElement('b'); b.textContent = obj.lead; el.appendChild(b); el.appendChild(document.createTextNode(' ')); }
    if (obj.rest) el.appendChild(document.createTextNode(obj.rest));
  }

  // ---- Aktive Schritte (Gravur nur wenn bestellt) ----
  function activeSteps(m) {
    var out = [], i, f = nounForms(m.productNoun), d;
    for (i = 0; i < STEP_DEFS.length; i++) {
      d = STEP_DEFS[i];
      if (d.key === 'gravur' && !m.gravur) continue;
      out.push({ key: d.key, name: (f.steps && f.steps[d.key]) || d.name });
    }
    return out;
  }

  function render(section, refs, m) {
    var steps = activeSteps(m);
    var n = steps.length;
    var curIdx = 0, found = false, i;
    for (i = 0; i < n; i++) { if (steps[i].key === m.currentKey) { curIdx = i; found = true; break; } }
    var nf = nounForms(m.productNoun);
    var pay = !!m.pay, delivered = !!m.delivered;
    // EIN Prozentwert für alles, was Fortschritt zeigt: Zahl im Kopf, Leiste (Handy), Grat, Punkt, Marke
    var pct = progressPct(m, steps, found ? curIdx : -1);
    var lay = stationPcts(steps, curIdx, pct);
    var sp = lay.p;
    var stX = sp.map(pctToX);
    var cxCss = sp.map(pctToCss);
    var g = geom(stX);
    // K2-Absicherung: fehlen Grafik-Refs (ältere Section), wird die Grafik nicht gezeichnet statt zu werfen
    var hasRidge = !!(refs.base && refs.prog && refs.shade && refs.clip && refs.stations);

    if (hasRidge) {
      // Ridge-Pfade + Clip: der Grat-Fortschritt endet genau bei pctToX(pct), dort steht auch der aktuelle Punkt
      refs.base.setAttribute('d', g.d);
      refs.prog.setAttribute('d', g.d);
      refs.shade.setAttribute('d', g.shade);
      refs.clip.setAttribute('width', r1(pctToX(pct)));

      // Stationen: zuerst die Lote (Strich von der Station zur Beschriftung), darüber die Punkte
      refs.stations.textContent = '';
      for (i = 0; i < n; i++) {
        var lx = r1(stX[i]), ly = r1(ridgeY(stX[i]));
        var lcur = i === curIdx && !delivered && !pay;
        refs.stations.appendChild(svgEl('path', {
          d: 'M' + lx + ' ' + r1(ly + (lcur && lay.onStation ? 15 : 11)) + ' V' + RIDGE.H,
          'class': 'awbs-lot' + (lcur ? ' is-current' : '')
        }));
      }
      // Startpfosten bei 0 % (aus K1): der Grat-Fortschritt beginnt sichtbar hier, nicht an der ersten Station
      refs.stations.appendChild(svgEl('path', {
        d: 'M' + r1(pctToX(0)) + ' ' + r1(ridgeY(pctToX(0)) - 7) + ' V' + r1(ridgeY(pctToX(0)) + 7),
        'class': 'awbs-start' + (pct > 0 ? ' is-done' : '')
      }));
      // Zahlung offen: 0 %, nichts ist erledigt. Der Eingang trägt keinen Haken, der Punkt ist hell und hohl.
      function drawCurrent(x, withRing) {
        var y = ridgeY(x);
        if (withRing) refs.stations.appendChild(svgEl('circle', { cx: r1(x), cy: r1(y), r: 13, 'class': 'awbs-ring' }));
        refs.stations.appendChild(svgEl('circle', { cx: r1(x), cy: r1(y), r: 9, 'class': 'awbs-dot is-current' + (pay ? ' is-pay' : '') }));
      }
      for (i = 0; i < n; i++) {
        var done = i < curIdx || (i === curIdx && delivered);
        var cur = i === curIdx && !delivered && lay.onStation;
        var x = stX[i], y = ridgeY(x);
        if (cur) { drawCurrent(x, !pay); continue; }
        refs.stations.appendChild(svgEl('circle', {
          cx: r1(x), cy: r1(y), r: 7.5,
          'class': 'awbs-dot ' + (done ? 'is-done' : 'is-upcoming') + (i === curIdx && !delivered ? ' is-active' : '')
        }));
        if (done) {
          refs.stations.appendChild(svgEl('path', {
            d: 'M' + r1(x - 3.6) + ' ' + r1(y) + ' l2.6 2.8 l4.8 -5.4', 'class': 'awbs-check'
          }));
        }
      }
      // Punkt zwischen zwei Stationen (unterwegs vor dem Gipfel, abweichende Backend-Werte): steht auf pct
      if (!delivered && !lay.onStation) drawCurrent(pctToX(pct), !pay);
      // Gipfel-Fähnchen (gold erst bei Zustellung)
      var reached = delivered ? ' is-reached' : '';
      refs.stations.appendChild(svgEl('path', { d: 'M' + r1(g.xR) + ' ' + r1(g.yT - 8) + ' V' + r1(g.yT - 24), 'class': 'awbs-mast' + reached }));
      refs.stations.appendChild(svgEl('path', {
        d: 'M' + r1(g.xR + 1.5) + ' ' + r1(g.yT - 23.5) + ' L' + r1(g.xR + 14.5) + ' ' + r1(g.yT - 20) + ' L' + r1(g.xR + 1.5) + ' ' + r1(g.yT - 16.5) + ' Z',
        'class': 'awbs-wimpel' + reached
      }));
    }

    // Datums-Sub (Versanddauer) je Schritt
    function subFor(key) {
      // Wortverbinder um den Bis-Strich: am Handy brach „1–3 Werktage“ sonst hinter dem Strich um
      if (key === 'versand' && m.shipTitle && m.shipDuration) return m.shipTitle + ': ' + String(m.shipDuration).replace(/(\d)\s*–\s*(\d)/g, '$1⁠–⁠$2');
      return '';
    }

    // Marke mit der Zahl am Anker-Punkt (Desktop). Am Gipfel über das Fähnchen gehoben, sonst träfe sie es.
    // Zahlung offen: helle Marke mit Rand (aus K2), „0 %“ soll nach „noch nicht gestartet“ aussehen.
    if (refs.mark && refs.markNum && hasRidge) {
      refs.markNum.textContent = String(pct);
      refs.mark.style.setProperty('--awbs-mx', String(pctToCss(pct)));
      refs.mark.style.setProperty('--awbs-my', String(r2(ridgeY(pctToX(pct)) / RIDGE.H * 100)));
      refs.mark.classList.toggle('is-top', pct >= 97);
      refs.mark.classList.toggle('is-pay', pay);
      refs.mark.hidden = false;
      // Mehr Luft über der Grafik nur, wenn die Marke über das Fähnchen gehoben ist
      if (refs.timeline) refs.timeline.classList.toggle('is-mark-top', pct >= 97);
    }
    if (!refs.steps || !refs.vsteps) { renderRest(section, refs, m, steps, curIdx, pct, nf, pay, delivered); return; }

    // Labels (Desktop): zwei versetzte Reihen, x je Station aus pctToCss, Strich zeigt auf die Station
    var slots = labelSlots(cxCss);
    // Eine Wahrheit für den aktiven Schritt: steht der Punkt am Grat zwischen zwei Stationen (unterwegs, 95 %),
    // ist die aktive Station noch nicht erreicht. Das Handy zeigt dann dasselbe: aktive Station hohl
    // (is-zwischen), der gelbe Punkt sitzt auf der Verbindung davor (is-weg). Vorher trug das Handy den gelben
    // Punkt auf „Zugestellt“, der Desktop den Punkt vor dem hohlen Gipfel.
    var zwischen = found && !delivered && !pay && !lay.onStation;
    refs.steps.style.setProperty('--awbs-n', n);
    refs.steps.textContent = '';
    refs.vsteps.textContent = '';
    for (i = 0; i < n; i++) {
      var doneL = i < curIdx || (i === curIdx && (delivered || pay));
      var curL = i === curIdx && !delivered && !pay;
      var cls = curL ? 'is-current' : doneL ? 'is-done' : 'is-upcoming';
      var dt = (m.dates && m.dates[steps[i].key]) || '';
      var sub = subFor(steps[i].key);

      var step = document.createElement('div');
      step.className = 'awbs-step ' + cls + (slots[i].row === 2 ? ' is-row2' : '');
      step.style.setProperty('--awbs-cx', String(cxCss[i]));
      step.style.setProperty('--awbs-lb', String(r2(slots[i].lb)));
      step.style.setProperty('--awbs-rb', String(r2(slots[i].rb)));
      step.style.setProperty('--awbs-lbm', slots[i].lbm + 'px');
      step.style.setProperty('--awbs-rbm', slots[i].rbm + 'px');
      var nm = document.createElement('div'); nm.className = 'awbs-step__nm'; nm.textContent = steps[i].name;
      var dd = document.createElement('div'); dd.className = 'awbs-step__dt'; dd.textContent = dt;
      if (sub) { var s = document.createElement('span'); s.className = 'awbs-step__sub'; s.textContent = sub; dd.appendChild(s); }
      step.appendChild(nm); step.appendChild(dd); refs.steps.appendChild(step);

      var v = document.createElement('div');
      v.className = 'awbs-vstep ' + cls + (zwischen && i === curIdx ? ' is-zwischen' : '') + (zwischen && i === curIdx - 1 ? ' is-weg' : '');
      var vdot = document.createElement('span'); vdot.className = 'awbs-vdot';
      var vbox = document.createElement('div');
      var vnm = document.createElement('div'); vnm.className = 'awbs-vnm'; vnm.textContent = steps[i].name;
      // Kein Termin („–“, z. B. Zahlung offen): am Handy nur der Versandzusatz. Vorher stand „– · Standard: 1–3 Werktage“.
      var ohneTermin = !dt || /^\s*[–-]\s*$/.test(dt);
      var vdt = document.createElement('div'); vdt.className = 'awbs-vdt'; vdt.textContent = sub && ohneTermin ? '' : dt;
      if (sub) { var vs = document.createElement('span'); vs.className = 'awbs-vsub'; vs.textContent = (ohneTermin ? '' : ' · ') + sub; vdt.appendChild(vs); }
      vbox.appendChild(vnm); vbox.appendChild(vdt);
      v.appendChild(vdot); v.appendChild(vbox); refs.vsteps.appendChild(v);
    }
    renderRest(section, refs, m, steps, curIdx, pct, nf, pay, delivered);
  }

  function renderRest(section, refs, m, steps, curIdx, pct, nf, pay, delivered) {
    // Kopf-Meta
    refs.order.textContent = 'Bestellung ' + (m.order || '');
    refs.placed.textContent = m.placed ? 'Bestellt am ' + m.placed : '';
    refs.ship.textContent = '';
    if (m.shipTitle) {
      refs.ship.appendChild(document.createTextNode('Versandart: '));
      var sb = document.createElement('b');
      sb.textContent = m.shipTitle + (m.shipExtra ? ' · ' + m.shipExtra : '');
      refs.ship.appendChild(sb);
    }
    // Prio-Badge
    if (m.prioLabel) { refs.prioLabel.textContent = m.prioLabel; refs.prio.hidden = false; }
    else { refs.prio.hidden = true; }
    // Zahlung ausstehend
    refs.paybadge.hidden = !pay;
    refs.paynote.hidden = !pay;
    // ETA
    refs.etaLabel.textContent = m.etaLabel || '';
    refs.etaValue.textContent = m.etaValue || '';
    refs.etaSub.textContent = m.etaSub || '';
    // Sendungsverfolgung gilt für die ganze Bestellung: EINMAL im Kopf beim Versanddatum. An Karte 1 wirkte
    // sie bei mehreren Positionen, als ginge nur dieses Werkstück auf die Reise (Abnahme 13.09.2026).
    if (refs.track) {
      if (m.track && m.trackUrl) {
        refs.track.setAttribute('href', m.trackUrl);
        if (refs.trackLabel) refs.trackLabel.textContent = 'Sendung verfolgen' + (m.trackCarrier ? ' (' + m.trackCarrier + ')' : '');
        refs.track.hidden = false;
      } else refs.track.hidden = true;
    }
    // Status-Satz
    setLeadText(refs.now, m.now);
    // Fortschritt in Prozent (Kopf). Fehlt das Markup (ältere Section), bleibt alles wie bisher.
    // Desktop: nur die Zahl (die Leiste ist der Grat), Handy: Zahl und Leiste. Beide aus demselben pct.
    if (refs.progress && refs.progressNum) {
      refs.progressNum.textContent = String(pct);
      refs.progress.style.setProperty('--awbs-pct', pct + '%');
      refs.progress.setAttribute('aria-valuenow', String(pct));
      var curStep = steps[curIdx];
      refs.progress.setAttribute('aria-valuetext', pct + ' %' + (curStep && !delivered && !pay ? ', ' + curStep.name : ''));
      refs.progress.hidden = false;
    }
    // Überschrift: nur ersetzen, solange sie ein Standardtext ist (eigener Text im Editor hat Vorrang)
    if (refs.heading && STD_HEADINGS.indexOf(refs.heading.textContent.trim()) > -1) {
      refs.heading.textContent = nf.frage;
    }

    renderModels(section, refs, m);
    renderAdressen(refs, m.adressen);
    show(section, 'result');
  }

  // ---- Adressen (status_api „adressen“) ----
  // zugang konto: Liefer- und Rechnungsanschrift vollständig, bei gleicher Anschrift rechnung null und der Satz
  // „Rechnungsanschrift wie Lieferanschrift“. zugang link (weiterleitbarer Mail-Link): nur die gekürzte
  // Lieferanschrift, Hinweis aufs Kundenkonto. Eine Rechnungsanschrift erscheint ausschließlich im Konto-Modus,
  // auch wenn ein fehlerhaftes Backend im Link-Modus eine mitschickt. adressen null: kein Block.
  function fillAdr(el, a) {
    el.textContent = '';
    if (!a) return;
    if (a.name) { var b = document.createElement('b'); b.textContent = a.name; el.appendChild(b); }
    a.zeilen.concat(a.land ? [a.land] : []).forEach(function (z) {
      var s = document.createElement('span'); s.textContent = z; el.appendChild(s);
    });
  }
  function renderAdressen(refs, ad) {
    if (!refs.addr) return;
    // Abholung (konto): liefer null, rechnung gesetzt -> nur die Rechnungskarte. Ohne Lieferanschrift gibt es kein
    // „wie Lieferanschrift“, ein gleich-Flag allein erzeugt also keinen leeren Block.
    if (!ad || (!ad.liefer && !(ad.konto && ad.rechnung))) { refs.addr.hidden = true; return; }
    fillAdr(refs.addrLieferAdr, ad.liefer);
    refs.addrLiefer.hidden = !ad.liefer;
    var zeigeRechnung = ad.konto && (!!ad.rechnung || (ad.gleich && !!ad.liefer));
    fillAdr(refs.addrRechnungAdr, ad.konto && !ad.gleich ? ad.rechnung : null);
    refs.addrRechnungAdr.hidden = !(ad.konto && !ad.gleich && ad.rechnung);
    refs.addrGleich.hidden = !(ad.konto && ad.gleich && ad.liefer);
    refs.addrRechnung.hidden = !zeigeRechnung;
    refs.addrHint.hidden = !ad.gekuerzt;
    refs.addr.hidden = false;
  }
  function normAdresse(a) {
    if (!a || typeof a !== 'object') return null;
    var zeilen = (Array.isArray(a.zeilen) ? a.zeilen : []).map(function (z) { return String(z == null ? '' : z).trim(); })
      .filter(function (z) { return z; });
    var n = String(a.name || '').trim(), land = String(a.land || '').trim();
    return n || zeilen.length || land ? { name: n, zeilen: zeilen, land: land } : null;
  }
  function normAdressen(ad) {
    if (!ad || typeof ad !== 'object') return null;
    var konto = ad.zugang === 'konto';
    return {
      konto: konto,
      liefer: normAdresse(ad.liefer),
      rechnung: konto ? normAdresse(ad.rechnung) : null,
      gleich: konto && !!ad.rechnung_gleich_liefer,
      // Nicht-Konto-Zugang gilt immer als gekürzt, auch wenn das Flag fehlt
      gekuerzt: !konto || !!ad.gekuerzt
    };
  }

  // ---- Modell-Karten: eine Karte je Werkstück-Position (status_api.positions) ----
  // Stephan 13.09.2026: „Und wo ist das Rendering???“ · „Beim gravurtext keine anführungszeichen…. Das kann
  // falsch verstanden werden“. Die erste Karte ist die aus der Section, jede weitere ist eine Kopie der
  // unberührten Vorlage (section._modelTpl) mit data-awbs-pos. Bild NUR bei render_art „render“ (echtes Render
  // der bestellten Config). Ein Katalog- oder Positionsfoto zeigt eine andere Strecke und eine fremde Gravur
  // (26-14325: TDS statt OCC), deshalb gibt es kein Ersatzfoto: ohne Render kein Bild, der 3D-Link bleibt.
  // Stephan 13.09.2026: „Falls du ein Rendering nicht findest, dann sollst Du natürlich keinen Fehler anzeigen,
  // sondern entweder weglassen oder auf den 3D-Vorschau Link verweisen.“ Gilt auch, wenn ein älteres Backend
  // noch render_art=produktbild liefert. Gravurtext ohne Anführungszeichen, der Block „Deine Gravur“ grenzt ihn
  // ab, Zeilenumbrüche und mehrfache Leerzeichen bleiben (white-space:pre-wrap, 26-12747).
  // Umbruch nur an den Trennstrichen, nie zwischen Wort und Zahl oder Zahl und Einheit: bei 390 px stand
  // „… | Place“ / „435“ (Abnahme 08.10.2026, 26-14378). Geschütztes Leerzeichen bindet „|“ an das Wort davor
  // (wie im Titel), ein Wort an die folgende Zahl und eine Zahl an ihre Einheit. Zeilenumbrüche bleiben.
  // 15.10.2026 (S-26-00400): Nur das EINE Leerzeichen direkt vor „|“ wird geschützt. Vorher fasste
  // /[ \t]+\|/ mehrere Leerzeichen oder Tabs zu einem zusammen, der sichtbare Text war dann nicht
  // mehr zeichengenau. Die anderen Ersetzungen tauschen nur U+0020 gegen U+00A0 (gleiches Schriftbild).
  function gravurUmbruch(t) {
    return String(t)
      .replace(/ \|/g, ' |')
      .replace(/([A-Za-zÄÖÜäöüß]) (?=\d)/g, '$1 ')
      .replace(/(\d) (?=(?:km|hm|Hm|m\+?|mi|ft|hrs?|h|min)(?=[\s,.;|]|$))/g, '$1 ');
  }

  function fillCard(section, card, pos, idx, total, m) {
    function c(sel) { return q(card, sel); }
    var pf = nounForms(pos.noun);
    var showImg = section._zeigeRender && !!pos.renderUrl && pos.renderArt === 'render';
    card.setAttribute('data-awbs-pos', String(idx));
    card.classList.toggle('is-noimg', !showImg);
    if (c('model-img')) c('model-img').hidden = !showImg;
    if (c('model-tag')) { c('model-tag').textContent = pf.dein; c('model-tag').hidden = !showImg; }
    if (c('render')) {
      if (showImg) {
        c('render').setAttribute('src', pos.renderUrl);
        c('render').setAttribute('alt', 'Vorschau ' + pf.deines + (pos.title ? ': ' + pos.title : ''));
      } else {
        c('render').removeAttribute('src');
        c('render').setAttribute('alt', '');
      }
    }
    if (c('model-eyebrow')) c('model-eyebrow').textContent = total > 1 ? pos.noun + ' · ' + (idx + 1) + ' von ' + total : 'Dein Modell';
    // Umbruch nur nach dem Trennstrich: geschütztes Leerzeichen bindet „|“ an das Wort davor.
    // Am Handy stand sonst „Relief Natural“ / „| Individuell“ (Abnahme 13.09.2026).
    if (c('model-title')) c('model-title').textContent = String(pos.title || 'Dein Modell').replace(/\s+\|/g, ' |');
    var specs = c('specs');
    if (specs) {
      specs.textContent = '';
      var list = (pos.specs || []).slice();
      if (pos.quantity >= 2) list.unshift({ k: 'Menge', v: pos.quantity + ' Stück' });
      list.forEach(function (sp) {
        var dt = document.createElement('dt'); dt.textContent = sp.k;
        var dd = document.createElement('dd'); dd.textContent = sp.v;
        specs.appendChild(dt); specs.appendChild(dd);
      });
      specs.hidden = !list.length;
    }
    var gtxt = (pos.gravurTexts && pos.gravurTexts.length ? pos.gravurTexts.join('\n\n') : pos.gravurText || '').trim();
    if (c('gravur')) {
      if (m.gravur && gtxt && c('gravur-text')) { c('gravur-text').textContent = gravurUmbruch(gtxt); c('gravur').hidden = false; }
      else c('gravur').hidden = true;
    }
    var view = c('view'), note = c('view-note');
    if (view) {
      if (pos.viewUrl) { view.setAttribute('href', pos.viewUrl); view.hidden = false; if (note) note.hidden = false; }
      else { view.hidden = true; if (note) note.hidden = true; }
    }
  }

  function renderModels(section, refs, m) {
    if (!refs.modelCard) return;
    // Demo-Daten und ältere Modelle ohne positions: eine Karte aus den Feldern der Bestellung
    var list = m.positions && m.positions.length ? m.positions : [{
      noun: NOUNS[m.productNoun] && m.productNoun !== 'Bestellung' ? m.productNoun : 'Relief',
      title: m.modelTitle || '', quantity: 1, specs: m.specs || [], gravurText: m.gravurText || '', gravurTexts: [],
      viewUrl: m.viewUrl || '', renderUrl: m.renderUrl || '', renderArt: m.renderUrl ? 'render' : ''
    }];
    var host = refs.modelCard.parentNode;
    // Kopien eines früheren Renders (Dev-Umschalter, Neu-Laden) entfernen
    [].slice.call(host.querySelectorAll('[data-awbs="model-card"]')).forEach(function (el) {
      if (el !== refs.modelCard) el.remove();
    });
    if (!list.length) { refs.modelCard.hidden = true; return; }
    refs.modelCard.hidden = false;
    var prev = refs.modelCard;
    list.forEach(function (pos, i) {
      var card = i === 0 ? refs.modelCard : section._modelTpl.cloneNode(true);
      fillCard(section, card, pos, i, list.length, m);
      if (i > 0) { prev.parentNode.insertBefore(card, prev.nextSibling); prev = card; }
    });
  }

  // ---- Views umschalten ----
  function show(section, view) {
    section.querySelectorAll('[data-awbs-view]').forEach(function (el) {
      el.hidden = el.getAttribute('data-awbs-view') !== view;
    });
  }

  // ---- Refs einsammeln ----
  function collect(section) {
    var r = {
      base: q(section, 'base'), prog: q(section, 'prog'), shade: q(section, 'shade'),
      clip: q(section, 'clip'), stations: q(section, 'stations'),
      steps: q(section, 'steps'), vsteps: q(section, 'vsteps'), now: q(section, 'now'),
      order: q(section, 'order'), placed: q(section, 'placed'), ship: q(section, 'ship'),
      prio: q(section, 'prio'), prioLabel: q(section, 'prio-label'),
      paybadge: q(section, 'paybadge'), paynote: q(section, 'paynote'),
      etaLabel: q(section, 'eta-label'), etaValue: q(section, 'eta-value'), etaSub: q(section, 'eta-sub'),
      progress: q(section, 'progress'), progressNum: q(section, 'progress-num'), progressBar: q(section, 'progress-bar'),
      mark: q(section, 'mark'), markNum: q(section, 'mark-num'), timeline: section.querySelector('.awbs-timeline'),
      heading: section.querySelector('.awbs-hero__title'),
      modelImg: q(section, 'model-img'), modelCard: q(section, 'model-card'), render: q(section, 'render'),
      modelTag: q(section, 'model-tag'),
      modelTitle: q(section, 'model-title'), specs: q(section, 'specs'),
      gravur: q(section, 'gravur'), gravurText: q(section, 'gravur-text'),
      view: q(section, 'view'), viewNote: q(section, 'view-note'),
      track: q(section, 'track'), trackLabel: q(section, 'track-label'),
      addr: q(section, 'addr'), addrLiefer: q(section, 'addr-liefer'), addrLieferAdr: q(section, 'addr-liefer-adr'),
      addrRechnung: q(section, 'addr-rechnung'), addrRechnungAdr: q(section, 'addr-rechnung-adr'),
      addrGleich: q(section, 'addr-gleich'), addrHint: q(section, 'addr-hint')
    };
    // Adressblock nur mit vollständigem Markup (ältere Section ohne Adressen: nichts zeichnen statt zu werfen)
    if (!(r.addr && r.addrLiefer && r.addrLieferAdr && r.addrRechnung && r.addrRechnungAdr && r.addrGleich && r.addrHint)) r.addr = null;
    return r;
  }

  // ---- API-JSON -> internes Modell (defensiv, Backend folgt) ----
  function mapApi(j, section) {
    j = j || {};
    var cid = j.config_id || j.configId || '';
    var viewUrl = j.view_url || (cid ? 'https://app.alpen-werk.de/view/' + cid : '');
    // Seit status_api v2.0800 entscheidet das Backend per HEAD, ob ein echtes Render existiert (render_art).
    // Nur ein älteres Backend ohne render_art bekommt noch die aus der Config-ID gebaute Render-URL.
    var neuesBackend = j.render_art !== undefined || Array.isArray(j.positions);
    var renderUrl = j.render_url || (!neuesBackend && cid ? 'https://app.alpen-werk.de/render/' + cid + '.jpg' : '');
    var noun = j.product_noun || j.productNoun || 'Relief';
    var gravurText = j.gravur_text || j.gravurText || '';
    var positions = (Array.isArray(j.positions) ? j.positions : []).map(function (p) {
      p = p || {};
      return {
        noun: NOUNS[p.product_noun] ? p.product_noun : 'Relief',
        title: p.title || '', quantity: Number(p.quantity) || 1, specs: p.specs || [],
        gravurText: p.gravur_text || '', gravurTexts: Array.isArray(p.gravur_texts) ? p.gravur_texts : [],
        viewUrl: p.view_url || '', renderUrl: p.render_url || '', renderArt: p.render_art || ''
      };
    });
    // Älteres Backend ohne positions: eine Karte aus den Feldern der Bestellung
    if (!positions.length) positions.push({
      noun: noun === 'Bestellung' || !NOUNS[noun] ? 'Relief' : noun,
      title: j.model_title || j.title || '', quantity: 1, specs: j.specs || [],
      gravurText: gravurText, gravurTexts: [], viewUrl: viewUrl, renderUrl: renderUrl,
      renderArt: j.render_art || (renderUrl ? 'render' : '')
    });
    var fin = (j.financial_status || 'paid').toLowerCase();
    var pay = j.pay != null ? !!j.pay : (fin !== 'paid' && fin !== 'partially_refunded' && fin !== 'refunded');
    var prio = (j.prio || 'standard').toLowerCase();
    return {
      order: j.order_name || j.order || '',
      placed: j.placed || j.placed_at || '',
      prioLabel: j.prio_label || (prio === 'express' ? 'Express' : prio === 'prio' ? 'Prio' : ''),
      shipTitle: j.shipping_title || j.ship_title || '',
      shipExtra: j.shipping_extra || j.ship_extra || '',
      shipDuration: j.shipping_duration || j.ship_duration || '',
      gravur: !!j.gravur, gravurText: gravurText,
      gravurTexts: Array.isArray(j.gravur_texts) ? j.gravur_texts : [],
      positions: positions, renderArt: j.render_art || '',
      pay: pay, delivered: !!(j.delivered || fin === 'delivered' || j.shipment_status === 'delivered'),
      currentKey: j.current_key || j.currentKey || 'eingang',
      productNoun: noun,
      progressPct: j.progress_pct != null ? j.progress_pct : null,
      dates: j.dates || {},
      now: j.now && (j.now.lead || j.now.rest) ? j.now : { rest: j.now_text || '' },
      etaLabel: j.eta_label || '', etaValue: j.eta_value || '', etaSub: j.eta_sub || '',
      track: j.track != null ? !!j.track : !!j.tracking_url,
      trackUrl: j.tracking_url || '', trackCarrier: j.tracking_carrier || j.carrier || '',
      modelTitle: j.model_title || j.title || 'Dein Modell',
      specs: j.specs || [],
      viewUrl: viewUrl, renderUrl: renderUrl,
      adressen: normAdressen(j.adressen)
    };
  }

  // ---- Demo-Daten (aus dem Mockup) ----
  function demoModel(state, section) {
    var opts = section._demoOpts, prio = opts.prio, gravur = opts.gravur;
    var base = {
      order: '26-13642',
      productNoun: 'Relief',
      shipTitle: 'DHL Paket',
      shipExtra: prio ? 'Priorisierte Fertigung (2–3 Werktage)' : '',
      shipDuration: '1–3 Werktage',
      prioLabel: prio ? 'Prio' : '',
      gravur: gravur, gravurText: 'Watzmann 2.713 m · Unser Gipfel, Juli 2026',
      modelTitle: 'Relief Natural · Watzmann',
      specs: [
        { k: 'Größe', v: 'L · 20 × 20 cm' },
        { k: 'Ausführung', v: 'Base, Eiche' },
        { k: 'Farbwelt', v: 'Natural, Sommer' }
      ],
      viewUrl: 'https://app.alpen-werk.de/view/05f67b866816',
      renderUrl: section._demoRender,
      trackCarrier: 'DHL', trackUrl: 'https://www.dhl.de/de/privatkunden/pakete-empfangen/verfolgen.html',
      // Synthetische Anschrift (Konto-Modus), nie echte Kundendaten in Demo-Daten
      adressen: normAdressen({
        zugang: 'konto', rechnung_gleich_liefer: true, gekuerzt: false, rechnung: null,
        liefer: { name: 'Anna Beispiel', zeilen: ['Musterweg 1', '83324 Ruhpolding'], land: 'Deutschland' }
      })
    };
    var D = {
      eingang: {
        currentKey: 'eingang',
        dates: { eingang: 'heute, 14:32', modell: 'voraussichtlich Fr. 17. Juli', druck: 'voraussichtlich Mo. 20. Juli', gravur: 'voraussichtlich Di. 21. Juli', montage: 'voraussichtlich Mi. 22. Juli', versand: 'voraussichtlich Mi. 22. Juli', zustellung: 'voraussichtlich Do. 23.–Mi. 29. Juli' },
        now: { lead: 'Danke für Deine Bestellung!', rest: 'Wir haben sie erhalten und bereiten Dein 3D-Modell vor.' },
        etaLabel: 'Voraussichtliche Zustellung', etaValue: 'Do. 23. bis Mi. 29. Juli', etaSub: 'Innerhalb des zugesagten Lieferfensters Deiner Bestellung.'
      },
      modell: {
        currentKey: 'modell',
        dates: { eingang: 'Mi. 9. Juli, 14:32', modell: 'Do. 10. Juli', druck: 'voraussichtlich Mo. 14. Juli', gravur: 'voraussichtlich Di. 15. Juli', montage: 'voraussichtlich Mi. 16. Juli', versand: 'voraussichtlich Mi. 16. Juli', zustellung: 'voraussichtlich Mo. 20.–Fr. 24. Juli' },
        now: { lead: 'Dein 3D-Modell ist erstellt und geprüft.', rest: 'Wir haben es aus Deinem Kartenausschnitt gebaut und von Hand geprüft. Als Nächstes geht es in den 3D-Druck.' },
        etaLabel: 'Voraussichtliche Zustellung', etaValue: 'Mo. 20. bis Fr. 24. Juli', etaSub: 'Innerhalb des zugesagten Lieferfensters Deiner Bestellung.'
      },
      druck: {
        currentKey: 'druck',
        dates: { eingang: 'Mi. 9. Juli, 14:32', modell: 'Do. 10. Juli', druck: 'seit heute', gravur: 'voraussichtlich Fr. 17. Juli', montage: 'voraussichtlich Mo. 20. Juli', versand: 'voraussichtlich Mo. 20. Juli', zustellung: 'voraussichtlich Mo. 20.–Fr. 24. Juli' },
        now: { lead: 'Gerade im 3D-Druck:', rest: 'Dein Relief entsteht Schicht für Schicht. Danach geht es in die Gravur.' },
        etaLabel: 'Voraussichtliche Zustellung', etaValue: 'Mo. 20. bis Fr. 24. Juli', etaSub: 'Innerhalb des zugesagten Lieferfensters Deiner Bestellung.'
      },
      gravur: {
        currentKey: 'gravur',
        dates: { eingang: 'Mi. 9. Juli, 14:32', modell: 'Do. 10. Juli', druck: 'Do. 16. Juli, 15:40', gravur: 'seit Fr. 17. Juli', montage: 'voraussichtlich Mo. 20. Juli', versand: 'voraussichtlich Mo. 20. Juli', zustellung: 'voraussichtlich Mo. 20.–Fr. 24. Juli' },
        now: { lead: 'Dein Relief ist gedruckt.', rest: 'Jetzt wird Dein Wunschtext graviert.' },
        etaLabel: 'Voraussichtliche Zustellung', etaValue: 'Mo. 20. bis Fr. 24. Juli', etaSub: 'Innerhalb des zugesagten Lieferfensters Deiner Bestellung.'
      },
      montage: {
        currentKey: 'montage',
        dates: { eingang: 'Mi. 9. Juli, 14:32', modell: 'Do. 10. Juli', druck: 'Do. 16. Juli, 15:40', gravur: 'Fr. 17. Juli', montage: 'seit Mo. 20. Juli', versand: 'voraussichtlich Mo. 20. Juli', zustellung: 'voraussichtlich Di. 21.–Fr. 24. Juli' },
        now: { lead: 'Fast geschafft:', rest: 'Dein Relief wird von Hand auf den Eichensockel montiert und geht durch die letzte Qualitätsprüfung.' },
        etaLabel: 'Voraussichtliche Zustellung', etaValue: 'Di. 21. bis Fr. 24. Juli', etaSub: 'Innerhalb des zugesagten Lieferfensters Deiner Bestellung.'
      },
      versand: {
        currentKey: 'zustellung', track: true,
        dates: { eingang: 'Mi. 9. Juli, 14:32', modell: 'Do. 10. Juli', druck: 'Do. 16. Juli, 15:40', gravur: 'Fr. 17. Juli', montage: 'Mo. 20. Juli', versand: 'Mo. 20. Juli, 16:05', zustellung: 'voraussichtlich Mi. 22.–Fr. 24. Juli' },
        now: { lead: 'Dein Relief ist unterwegs!', rest: 'Übergeben an DHL, Sendungsnummer JJD0099 1234 5678. Zustellung voraussichtlich Mi. 22. bis Fr. 24. Juli.' },
        etaLabel: 'Versendet am', etaValue: 'Mo. 20. Juli', etaSub: 'Zustellung voraussichtlich Mi. 22. bis Fr. 24. Juli.'
      },
      zustellung: {
        currentKey: 'zustellung', delivered: true, track: true,
        dates: { eingang: 'Mi. 9. Juli, 14:32', modell: 'Do. 10. Juli', druck: 'Do. 16. Juli, 15:40', gravur: 'Fr. 17. Juli', montage: 'Mo. 20. Juli', versand: 'Mo. 20. Juli, 16:05', zustellung: 'Mi. 22. Juli, 11:34' },
        now: { lead: 'Zugestellt!', rest: 'Dein Relief ist angekommen. Wir wünschen Dir viel Freude mit Deinem Bergmoment.' },
        etaLabel: 'Zugestellt am', etaValue: 'Mi. 22. Juli', etaSub: 'Übergeben am Mi. 22. Juli um 11:34 Uhr.'
      },
      pay: {
        currentKey: 'eingang', pay: true,
        dates: { eingang: 'Mi. 9. Juli, 14:32', modell: 'nach Zahlungseingang', druck: '–', gravur: '–', montage: '–', versand: '–', zustellung: '–' },
        now: { lead: 'Zahlung ausstehend:', rest: 'Die Fertigung startet, sobald Deine Zahlung eingegangen ist.' },
        etaLabel: 'Voraussichtliche Zustellung', etaValue: 'Nach Zahlungseingang', etaSub: 'Das Lieferfenster rechnen wir ab Eingang Deiner Zahlung.'
      }
    };
    var s = D[state] || D.druck;
    var m = {}, k;
    for (k in base) { if (base.hasOwnProperty(k)) m[k] = base[k]; }
    for (k in s) { if (s.hasOwnProperty(k)) m[k] = s[k]; }
    m.placed = (m.dates && m.dates.eingang) || '';
    return m;
  }

  // ---- Dev-Umschalter (nur Shopify.designMode) ----
  function buildDev(section, refs) {
    var bar = document.createElement('div');
    bar.className = 'awbs-dev';
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', 'Demo: Fertigungsstand wählen');
    var states = [
      ['pay', '0 Zahlung offen'], ['eingang', '1 Eingang'], ['modell', '2 Modell'],
      ['druck', '3 Druck'], ['gravur', '4 Gravur'], ['montage', '5 Montage'],
      ['versand', '6 Versendet'], ['zustellung', '7 Zugestellt']
    ];
    var lbl = document.createElement('span'); lbl.className = 'awbs-dev__lbl'; lbl.textContent = 'Demo · Stand'; bar.appendChild(lbl);
    section._demoOpts = { prio: true, gravur: true };
    var current = 'druck';
    var stateBtns = {};
    function paint() {
      Object.keys(stateBtns).forEach(function (k) { stateBtns[k].setAttribute('aria-pressed', String(k === current)); });
      stateBtns.gravur.hidden = !section._demoOpts.gravur;
      prioBtn.setAttribute('aria-pressed', String(section._demoOpts.prio));
      gravBtn.setAttribute('aria-pressed', String(section._demoOpts.gravur));
      render(section, refs, demoModel(current, section));
    }
    states.forEach(function (st) {
      var b = document.createElement('button'); b.type = 'button'; b.textContent = st[1];
      b.addEventListener('click', function () { current = st[0]; paint(); });
      stateBtns[st[0]] = b; bar.appendChild(b);
    });
    var prioBtn = document.createElement('button'); prioBtn.type = 'button'; prioBtn.textContent = '⚡ Prio';
    prioBtn.addEventListener('click', function () { section._demoOpts.prio = !section._demoOpts.prio; paint(); });
    bar.appendChild(prioBtn);
    var gravBtn = document.createElement('button'); gravBtn.type = 'button'; gravBtn.textContent = '✎ Gravur';
    gravBtn.addEventListener('click', function () {
      section._demoOpts.gravur = !section._demoOpts.gravur;
      if (!section._demoOpts.gravur && current === 'gravur') current = 'druck';
      paint();
    });
    bar.appendChild(gravBtn);
    section.appendChild(bar);
    paint();
  }

  // ---- Live-Abruf ----
  // v18.07e: IMMER den Proxy fetchen — Shopify injiziert logged_in_customer_id serverseitig,
  // d.h. eingeloggte Kunden sehen ihren Status OHNE ?order=. Erst ein 401 ({zugang:'noetig'})
  // zeigt die Zugangs-Karte; Netz-/Serverfehler zeigen den Fehler-Zustand.
  function loadLive(section, refs) {
    var params = new URLSearchParams(window.location.search);
    var order = params.get('order');
    var url = section._endpoint;
    var q = [];
    if (order) q.push('order=' + encodeURIComponent(order));
    var sig = params.get('sig'); if (sig) q.push('sig=' + encodeURIComponent(sig));
    if (q.length) url += (url.indexOf('?') > -1 ? '&' : '?') + q.join('&');
    show(section, 'loading');
    fetch(url, { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (res) {
        if (res.status === 401) { show(section, 'access'); return null; }
        // 18.09.2026: Angemeldet, aber keine Bestellung unter diesem Konto. Vorher
        // fiel das in den catch und zeigte die Zugangskarte, als sei niemand
        // angemeldet. Das Backend schickt dafür grund=keine_bestellung.
        if (res.status === 404) {
          return res.json().catch(function () { return {}; }).then(function (j) {
            show(section, (j && j.grund === 'keine_bestellung') ? 'leer' : 'error');
            return null;
          });
        }
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (j) { if (j) render(section, refs, mapApi(j, section)); })
      .catch(function () { show(section, order ? 'error' : 'access'); });
  }

  function init(section) {
    if (section._awbsInit) return;
    section._awbsInit = true;
    var oldDev = section.querySelector('.awbs-dev');
    if (oldDev) oldDev.remove();
    var refs = collect(section);
    // Unberührte Vorlage für weitere Modell-Karten, bevor das erste Render sie befüllt
    if (refs.modelCard && !section._modelTpl) section._modelTpl = refs.modelCard.cloneNode(true);
    section._endpoint = section.getAttribute('data-endpoint') || '/apps/status';
    section._zeigeRender = section.getAttribute('data-zeige-render') !== 'false';
    section._demoRender = section.getAttribute('data-demo-render') || '';
    var demo = section.getAttribute('data-demo') === 'true';
    var designMode = !!(window.Shopify && window.Shopify.designMode);

    // Konto-Links: Anmeldung mit Rücksprung auf diese Statusseite derselben Bestellung (order/sig)
    var acc = kontoLink(section);
    section.querySelectorAll('[data-awbs-account]').forEach(function (a) { a.setAttribute('href', acc); });

    if (demo) {
      section._demoOpts = { prio: true, gravur: true };
      if (designMode) { buildDev(section, refs); }
      else { render(section, refs, demoModel('druck', section)); }
      return;
    }
    loadLive(section, refs);
  }

  function boot() {
    document.querySelectorAll('.awbs').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Theme-Editor: Section neu geladen
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector ? e.target.querySelector('.awbs') : null;
    if (s) { s._awbsInit = false; init(s); }
  });
})();
